export const FIELD_DATA_ATTR = 'data-bb-field';
export const FIELD_EDITABLE_ATTR = 'data-editable';

export const FIELD_ERROR_DATA_ATTR = 'data-bb-error';

export type FieldBBType = 'text' | 'email' | 'tel' | 'date';
export const FIELD_BB_TYPE: Record<'TEXT' | 'EMAIL' | 'TEL' | 'DATE', FieldBBType> = {
	TEXT: 'text',
	EMAIL: 'email',
	TEL: 'tel',
	DATE: 'date',
};

export type FieldBBErrorType = 'required' | 'email' | 'tel' | 'fullName';
export const FIELD_BB_ERROR_TYPE: Record<'required' | 'email' | 'tel' | 'fullName', FieldBBErrorType> = {
	required: 'required',
	email: 'email',
	tel: 'tel',
	fullName: 'fullName',
};

export const FIELD_BB_ERROR_STYLE = {
	TEXT: {
		COLOR: 'errorColor',
		FONT_FAMILY: 'errorFontFamily',
		FONT_WEIGHT: 'errorFontWeight',
		FONT_SIZE: 'errorFontSize',
		LINE_HEIGHT: 'errorLineHeight',
		TEXT_ALIGN: 'errorTextAlign',
		DIRECTION: 'errorDirection',
	},
	PADDING: {
		TOP: 'errorPaddingTop',
		RIGHT: 'errorPaddingRight',
		BOTTOM: 'errorPaddingBottom',
		LEFT: 'errorPaddingLeft',
	},
};

export const FIELD_BB_STYLE = {
	PADDING: {
		TOP: 'fieldPT',
		RIGHT: 'fieldPR',
		BOTTOM: 'fieldPB',
		LEFT: 'fieldPL',
	},
	TEXT: {
		PH_COLOR: 'placeholderColor',
	},
	BOX: {
		FILL: 'boxFill',
		STROKE: 'boxStroke',
		ICON_COLOR: 'boxIconColor',
	},
} as const;

export const FIELD_EDIT_MODE = {
	PLACEHOLDER: 'placeholder',
	VALUE: 'value',
};
